/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { PastTransaction } from '../../actions/ecomm-interfaces';
import { getCustomerOrderHistory } from '../../actions/helper-functions';

import { IEcommHistoryListData } from './ecomm-history-list.data';
import { IEcommHistoryListProps } from './ecomm-history-list.props.autogenerated';

export interface IEcommHistoryListViewProps extends IEcommHistoryListProps<IEcommHistoryListData> {
  orderHistory: PastTransaction[];
  filteredCategory: number;
}

/**
 *
 * EcommHistoryList component
 * @extends {React.PureComponent<IEcommHistoryListProps<IEcommHistoryListData>>}
 */
class EcommHistoryList extends React.PureComponent<IEcommHistoryListProps<IEcommHistoryListData>> {
  public state: any = { transactions: [], filteredCategory: 0 };

  public async componentDidMount() {
    const { context, data: { hierarchy } } = this.props;
    
    const customer = this.props.data.accountInformation?.result;
        
    if (customer) {
      const orderHistory = await getCustomerOrderHistory(context, hierarchy, customer, this.props.config.organisation ? this.props.config.organisation : 'BT', this.props.config.isUat, this.props.config.historyLimit, (this.props.config.srcForCustTransactions?this.props.config.srcForCustTransactions:"CH"));

      this.setState({ transactions: orderHistory });
    }
  }


  public render(): JSX.Element | null {
    const categories: string[] = this.props.data.filteredCategories.result ? this.props.data.filteredCategories.result.filteredCategories : [];

    const HistoryListViewProps = {
      ...this.props,
      orderHistory: this.state.transactions,
      filteredCategory: categories.length > 0 ? Number(categories[0]) : 0
    };
  
    return this.props.renderView(HistoryListViewProps);
  }
}

export default EcommHistoryList;
